<template>
  <div class="overflow-y-scroll">
    <div
      class="flex flex-col bg-white min-h-full transition-all duration-100 ease-in min-w-64 w-max-content w-max max-w-64 xxl:max-w-80 relative z-10"
    >
      <ul class="ml-5 mt-32">
        <!-- BEGIN List modules -->
        <li
          v-for="(mod, modIndex) in modules"
          :key="mod.id"
          :id="mod.id"
          class="list-none"
        >
          <!--            v-if="listPageTemplates.filter(t => mod.pages.filter(p => p.id == t.page_id).length > 0).length > 0"-->
          <div
            class="group leading-4 cursor-pointer table flex-wrap h-14 2xl:h-16 w-auto max-w-60 border border-transparent rounded-lg hover:bg-pink-600 hover:text-white focus:outline-none transition ease-in-out duration-150 text-gray-600"
            :class="{
              'bg-pink-300': parseInt(infosPage.id_module) === parseInt(mod.id),
            }"
            @click="infosPage.isFormChanged ? $emit('changePage') : null"
          >
            <div
              class="items-center p-4 2xl:p-5 rounded-lg text-indigo-600 group-hover:text-white group-hover:bg-pink-600 transition ease-in-out duration-150 m-1"
              :class="{
                'bg-pink-100':
                  parseInt(infosPage.id_module) === parseInt(mod.id),
              }"
            >
              <icon :name="mod.icon" />
            </div>

            <router-link
              :to="{
                name: firstPageInModule(mod).templates[0].type,

                params: {
                  id_template: 'default',
                  module: mod.name,
                  page: firstPageInModule(mod).name,
                },
              }"
              class="table-cell text-base align-middle pl-1 pr-3 group-hover:text-white"
              :class="{
                'text-gray-900': parseInt(infosPage.id_module) === mod.id,
              }"
            >
              {{ mod.display_name }}
            </router-link>
          </div>
          <!-- BEGIN List pages -->
          <ul
            class="pl-3"
            :class="{
              hidden: infosPage.id_module != mod.id,
              'xl:table-row': !(
                parseInt(infosPage.id_module) !== parseInt(mod.id)
              ),
            }"
          >
            <div
              v-for="(page, index) in mod.pages"
              :key="index"
              class="first:mt-5 ml-5 border-l border-gray-600 border-opacity-25 last:border-0"
            >
              <li
                v-for="(template, jndex) in templatesInPage(page)"
                :key="jndex"
                class="group list-none relative pb-6 pl-6 text-gray-600 text-sm font-light"
                :class="{
                  'text-gray-900 font-normal':
                    parseInt(infosPage.id_template) === parseInt(template.id),
                }"
                @click="$emit('changePage')"
              >
                <div v-if="template.template_id === null">
                  <div
                    class="absolute inline-block text-center -ml-8 py-1 px-1 border border-gray-600 rounded-full border-opacity-25 bg-gray-300 group-hover:border-gray-600"
                    :class="{
                      'border-teal-600 bg-teal-300 group-hover:border-teal-600':
                        template.is_active,
                    }"
                  >
                    <icon
                      v-if="template.is_active"
                      name="checkmark"
                      class="text-teal-600 h-1.5 w-1.5"
                    />
                    <icon
                      v-else
                      name="minus"
                      class="text-gray-600 h-1.5 w-1.5"
                    />
                  </div>
                  <router-link
                    :to="{
                      name: template.type,
                      params: {
                        id_template: template.id,
                        module: template.module_name,
                        page: template.page_name,
                      },
                    }"
                    class="group-hover:font-normal transition-all ease-in-out duration-150"
                  >
                    {{ getPosition(template) }}
                  </router-link>
                </div>
              </li>
            </div>
            <!-- Button add a template for the module -->
            <li
              class="group list-none relative ml-5 pb-6 pl-6 text-gray-600 text-sm font-light"
              v-if="$can('templates_add')"
            >
              <div
                :id="parseInt(modIndex) === 0 ? 'tour_add_modele' : ''"
                class=""
                style="position: absolute !important"
              >
                <div
                  class="absolute inline-block text-center -ml-8 py-1 px-1 border border-pink-600 rounded-full border-opacity-25 bg-pink-300 group-hover:border-pink-600"
                >
                  <icon
                    name="plus"
                    class="text-pink-600 h-1.5 w-1.5"
                  />
                </div>
                <div
                  class="group-hover:font-normal transition-all ease-in-out duration-150 cursor-pointer relative"
                >
                  <!-- BEGIN Menu dropdown add template -->
                  <transition
                    enter-active-class="ease-out duration-150"
                    enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-active-class="ease-in duration-200"
                    leave-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  >
                    <div
                      class="dropdown-menu z-20 absolute left-0 top-5 mt-1 w-max-content w-max ml-auto rounded-md bg-white shadow-md shadow-gray-600 text-sm font-normal"
                      v-if="DropDownAddTemp == mod.id"
                      v-clickOutside="forceHide"
                    >
                      <div
                        v-if="
                          parseInt(DropDownAddTemp) === parseInt(mod.id) &&
                            mod.name ==
                            constants.MODULE_NEOPASS_FORM_COMPETENCES_PERSONNELLES
                        "
                        class="mx-5 my-3 text-left"
                      >
                        <div
                          class="cursor-pointer first:pt-3 last:pb-3 pb-1 text-gray-600 hover:text-gray-900"
                          @click="
                            newTemplate({
                              mod: constants.MODULE_NEOPASS_FORM_COMPETENCES_PERSONNELLES,
                              page: constants.PAGE_NEOPASS_FORM_COMPETENCES_CLES,
                              type: 'multi3',
                            })
                          "
                        >
                          Compétences clés
                        </div>
                        <div
                          class="cursor-pointer first:pt-3 last:pb-3 pb-1 text-gray-600 hover:text-gray-900"
                          @click="
                            newTemplate({
                              mod: constants.MODULE_NEOPASS_FORM_COMPETENCES_PERSONNELLES,
                              page: constants.PAGE_NEOPASS_FORM_NIVEAU_INFORMATIQUE,
                              type: 'multi3',
                            })
                          "
                        >
                          Compétences informatique
                        </div>
                        <div
                          class="cursor-pointer first:pt-3 last:pb-3 pb-1 text-gray-600 hover:text-gray-900"
                          @click="
                            newTemplate({
                              mod: constants.MODULE_NEOPASS_FORM_COMPETENCES_PERSONNELLES,
                              page: constants.PAGE_NEOPASS_FORM_COMPETENCES_LINGUISTIQUES,
                              type: 'multi1',
                            })
                          "
                        >
                          Compétences linguistiques
                        </div>
                      </div>
                      <div
                        v-else-if="
                          DropDownAddTemp === mod.id &&
                            mod.name ==
                            constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO
                        "
                        class="mx-5 my-3 text-left"
                      >
                        <div
                          class="cursor-pointer first:pt-3 last:pb-3 pb-1 text-gray-600 hover:text-gray-900"
                          @click="
                            newTemplate({
                              mod: constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO,
                              page: constants.PAGE_NEOPASS_FORM_APTITUDES_PERSONNELLES,
                              type: 'multi2',
                            })
                          "
                        >
                          Aptitudes Personnelles
                        </div>
                        <div
                          class="cursor-pointer first:pt-3 last:pb-3 pb-1 text-gray-600 hover:text-gray-900"
                          @click="
                            newTemplate({
                              mod: constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO,
                              page: constants.PAGE_NEOPASS_FORM_COMPORTEMENT_SOCIAL_RELATIONNEL,
                              type: 'multi2',
                            })
                          "
                        >
                          Comportement Social et Relationnel
                        </div>
                        <div
                          class="cursor-pointer first:pt-3 last:pb-3 pb-1 text-gray-600 hover:text-gray-900"
                          @click="
                            newTemplate({
                              mod: constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO,
                              page: constants.PAGE_NEOPASS_FORM_APTITUDES_TRAVAIL,
                              type: 'multi2',
                            })
                          "
                        >
                          Aptitudes au Travail
                        </div>
                        <div
                          class="cursor-pointer first:pt-3 last:pb-3 pb-1 text-gray-600 hover:text-gray-900"
                          @click="
                            newTemplate({
                              mod: constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO,
                              page: constants.PAGE_NEOPASS_FORM_PRODUCTIVITE_TECHNICITE,
                              type: 'multi2',
                            })
                          "
                        >
                          Productivité et technicité
                        </div>
                        <div
                          class="cursor-pointer first:pt-3 last:pb-3 pb-1 text-gray-600 hover:text-gray-900"
                          @click="
                            newTemplate({
                              mod: constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO,
                              page: constants.PAGE_NEOPASS_FORM_ATTITUDES_TRAVAIL,
                              type: 'multi2',
                            })
                          "
                        >
                          Attitudes au Travail
                        </div>
                        <div
                          class="cursor-pointer first:pt-3 last:pb-3 pb-1 text-gray-600 hover:text-gray-900"
                          @click="
                            newTemplate({
                              mod: constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO,
                              page: constants.PAGE_NEOPASS_FORM_RAPPORT_REGLES_CONTRAINTES,
                              type: 'multi2',
                            })
                          "
                        >
                          Rapport aux règles et aux contraintes
                        </div>
                      </div>
                      <div
                        v-else-if="
                          parseInt(DropDownAddTemp) === parseInt(mod.id) &&
                            mod.name ==
                            constants.MODULE_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES
                        "
                        class="mx-5 my-3 text-left"
                      >
                        <div
                          class="cursor-pointer first:pt-3 last:pb-3 pb-1 text-gray-600 hover:text-gray-900"
                          @click="
                            newTemplate({
                              mod: constants.MODULE_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES,
                              page: constants.PAGE_NEOPASS_FORM_POSTE_1,
                              type: 'pro',
                            })
                          "
                        >
                          Grille d'évaluation
                        </div>
                      </div>
                      <div
                        v-else-if="
                          parseInt(DropDownAddTemp) === parseInt(mod.id) &&
                            mod.name ==
                            constants.MODULE_NEOPASS_FORM_COMPETENCES_SCOLAIRES
                        "
                        class="mx-5 my-3 text-left"
                      >
                        <div
                          class="cursor-pointer first:pt-3 last:pb-3 pb-1 text-gray-600 hover:text-gray-900"
                          @click="
                            newTemplate({
                              mod: constants.MODULE_NEOPASS_FORM_COMPETENCES_SCOLAIRES,
                              page: constants.PAGE_NEOPASS_FORM_FORMATION_1,
                              type: 'sco',
                            })
                          "
                        >
                          Grille d'évaluation
                        </div>
                      </div>
                    </div>
                  </transition>
                  <!-- END Menu dropdown add template -->

                  <div
                    @click="displayDropDownAddTemp(mod.id)"
                    @click.stop
                  >
                    Ajouter une page &nbsp;
                    <icon
                      name="chevron-down"
                      class="dropdown-input font-normal text-pink-600 inline-block"
                    />
                  </div>
                </div>
              </div>
            </li>
            <!-- END Button add a template for the module -->
          </ul>
          <!-- END List pages -->
        </li>
        <!-- END List modules -->
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Icon from './Icon';
import Constants from './../constants';

export default {
  components: {
    Icon,
  },

  data: function () {
    return {
      DropDownAddTemp: -1,
      templatesPositionByModulePageType: {},
      constants: Constants,
    };
  },

  methods: {
    ...mapActions({
      add_template: 'template/add_template',
    }),
    displayDropDownAddTemp(mod) {
      if (this.DropDownAddTemp > -1) {
        this.DropDownAddTemp = -1;
      } else {
        this.DropDownAddTemp = mod;
      }
    },

    forceHide(e) {
      if (this.DropDownAddTemp > -1) {
        this.DropDownAddTemp = -1;
      }
    },

    newTemplate(infos) {
      this.DropDownAddTemp = -1;

      this.add_template(infos);
    },

    getPosition(template) {
      const moduleName = template.page.module.name;
      if (!this.templatesPositionByModulePageType[moduleName]) {
        this.templatesPositionByModulePageType[moduleName] = {};
      }

      const pageName = template.page.name;
      const type = template.type;
      if (
        !this.templatesPositionByModulePageType[moduleName][pageName + type]
      ) {
        this.templatesPositionByModulePageType[moduleName][pageName + type] =
          [];
      }

      if (
        this.templatesPositionByModulePageType[moduleName][
          pageName + type
        ].filter((b) => parseInt(b.id) === parseInt(template.id)).length === 0
      ) {
        const idx =
          [
            ...Object.keys(this.templatesPositionByModulePageType[moduleName]),
          ].indexOf(pageName + type) + 1;
        this.templatesPositionByModulePageType[moduleName][
          pageName + type
        ].push({
          id: template.id,
          pos:
            idx +
            '.' +
            (this.templatesPositionByModulePageType[moduleName][pageName + type]
              .length +
              1),
        });
      }

      const pos = this.templatesPositionByModulePageType[moduleName][
        pageName + type
      ].filter((temp) => parseInt(temp.id) === parseInt(template.id))[0].pos;

      return pos + ' ' + template.name;
    },

    numTemplate(i, id_module) {
      let count = 0;
      let mod = this.listModules.filter((m) => m.id == id_module)[0];

      mod.pages.forEach((element, index) => {
        if (index < i) {
          count += this.listPageTemplates.filter(
            (t) => t.page_name == element
          ).length;
        }
      });

      return count;
    },

    firstPageInModule(mod) {
      const hasPageTemplates = (page) => page.templates.length > 0;
      const pages = mod.pages.filter(hasPageTemplates);
      const locations = [...pages.map((page) => page.order)];
      const smallestLocation = Math.min(...locations);
      return pages.filter(
        (page) => parseInt(page.order) === parseInt(smallestLocation)
      )[0];
    },

    templatesInPage(page) {
      const templateIsUnique = (template) => template.template_id === null;
      const uniqueTemplates = this.listPageTemplates.filter(templateIsUnique);
      const templateIsInPage = (template) => template.page_name === page.name;
      const sortByPos = (a, b) => {
        [a, b] = [this.getPosition(a), this.getPosition(b)];
        if (a > b) {
          return 1;
        }
        if (b > a) {
          return -1;
        }
        return 0;
      };

      return uniqueTemplates.filter(templateIsInPage).sort(sortByPos);
    },
  },

  computed: {
    ...mapGetters({
      listPageTemplates: 'template/listPageTemplates',
      infosPage: 'template/infosPage',
      listModules: 'template/listModulesPages',
    }),

    modules() {
      return this.listModules.filter((module) =>
        module.pages.some((page) => page.templates.length > 0)
      );
    },
  },

  directives: {
    clickOutside: {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }

          console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener('click', handler);
      },

      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      },
    },
  },
};
</script>
